module.exports = __webpack_public_path__ + "img/overview.f3318194.png";